// Basic Accessibility Fixes
$(document).ready(function() {
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');

    // Remove empty Heading
    $('h1, h2, h3, h4, h5, h6').each(function () {
        if ($(this).text().trim() === '') {
            $(this).remove();
        }
    });
});

// color swatches warning on product page
$(document).ready(function () {
// Define the observer callback
  const observerCallback = function (mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        $(mutation.addedNodes).each(function () {
          // Check if the added node is the target UL or contains it
          if ($(this).is('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]') ||
              $(this).find('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]').length) {

            $('.form__width .product__form variant-swatch-king .swatches #swatch-group5450447 ul.swatch-view-image[role="radiogroup"], .form__width .product__form variant-swatch-king .swatches #swatch-group3978770 ul.swatch-view-custom-image').each(function () {
              if (!$(this).attr('aria-label')) {
                $(this).attr(
                  'aria-label',
                  'Choose a color. Product will refresh the page' 
                );
              }
            });
          }
        });
      }
    });
  };

  // Create the observer instance
  const observer = new MutationObserver(observerCallback);

  // Start observing the body for child node additions
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



//shop the button dialog fixed
$(document).ready(function() {
  $('#shop-the-room-button').on('click', function() {
    $('.px-look-drawer-close').focus();
  });

  $('.px-look-drawer-close').on('click', function() {
    $('#shop-the-room-button').focus();
  });
});


//shop the button pop up aria-state updated
$(document).ready(function() {
  function updateAriaHidden() {
    const $drawer = $('#drawer-template--18987291869357__shop_the_room_Rm43wa');

    if ($drawer.hasClass('px-look-drawer')) {
      $drawer.attr('aria-hidden', 'true');
    }

    if ($drawer.hasClass('active')) {
      $drawer.attr('aria-hidden', 'false');
    } else {
      $drawer.attr('aria-hidden', 'true');
    }
  }

  // Run once on load
  updateAriaHidden();

  // Optionally re-run on class change
  const observer = new MutationObserver(updateAriaHidden);
  observer.observe(document.getElementById('drawer-template--18987291869357__shop_the_room_Rm43wa'), {
    attributes: true,
    attributeFilter: ['class']
  });
});

// hidden content remove after header
$(document).ready(function () {
  // Check if it's desktop view (e.g., width >= 1024px)
  if ($(window).width() >= 769) {
    $('.search-popdown').remove();
  }
});

// Price accessibility labels
$(document).ready(function() {
  function updatePriceAccessibility() {
    // Regular/Sale Price
    $('.new-price, .product__price:not(.product__price--compare)').each(function() {
      var $this = $(this);
      var label = 'Price: ';
      
      // Check if on sale (class is usually on the child span or the element itself)
      if ($this.find('.product__price--sale').length > 0 || $this.hasClass('product__price--sale')) {
        label = 'Sale Price: ';
      }

      var $labelSpan = $this.find('.visually-hidden-price-label');
      
      if ($labelSpan.length === 0) {
        $this.prepend('<span class="visually-hidden visually-hidden-price-label">' + label + '</span>');
      } else {
        // Update label if state changed (e.g. variant switch)
        if ($labelSpan.text() !== label) {
          $labelSpan.text(label);
        }
      }
    });

    // Compare/Old Price
    $('.old-price, .product__price--compare').each(function() {
      if ($(this).find('.visually-hidden-price-label').length === 0) {
        $(this).prepend('<span class="visually-hidden visually-hidden-price-label">Original price: </span>');
      }
    });
  }

  // Run initially
  updatePriceAccessibility();

  // Observe for changes (AJAX loading or class changes)
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'class')) {
        shouldUpdate = true;
      }
    });
    if (shouldUpdate) {
      updatePriceAccessibility();
    }
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['class'] 
  });
});

// Product tabs keyboard navigation
$(document).ready(function() {
  function initTabAccessibility() {
    $('[data-tabs-holder]').each(function() {
      const $tabsHolder = $(this);
      const $tablist = $tabsHolder.find('[role="tablist"]');
      const $tabs = $tablist.find('[role="tab"]');
      const $panels = $tabsHolder.find('[role="tabpanel"]');
      
      if ($tabs.length === 0) return;

      // Click handler for tab activation
      $tabs.off('click.a11yTabs').on('click.a11yTabs', function(e) {
        e.preventDefault();
        activateTab($(this));
      });

      // Keyboard navigation
      $tabs.off('keydown.a11yTabs').on('keydown.a11yTabs', function(e) {
        const $currentTab = $(this);
        const currentIndex = $tabs.index($currentTab);
        let $targetTab = null;

        switch(e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            $targetTab = currentIndex > 0 ? $tabs.eq(currentIndex - 1) : $tabs.last();
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            $targetTab = currentIndex < $tabs.length - 1 ? $tabs.eq(currentIndex + 1) : $tabs.first();
            break;
          case 'Home':
            e.preventDefault();
            $targetTab = $tabs.first();
            break;
          case 'End':
            e.preventDefault();
            $targetTab = $tabs.last();
            break;
          default:
            return;
        }

        if ($targetTab) {
          activateTab($targetTab);
          $targetTab.focus();
        }
      });

      // Helper function to activate a tab
      function activateTab($tab) {
        const tabIndex = $tab.data('tab');
        
        // Update all tabs in this container
        $tabs.attr({
          'aria-selected': 'false',
          'tabindex': '-1'
        }).removeClass('current');

        // Update all panels in this container - use hidden attribute for proper accessibility
        $panels.each(function() {
          $(this)
            .attr('aria-hidden', 'true')
            .attr('hidden', true)
            .removeClass('current');
        });

        // Activate selected tab
        $tab.attr({
          'aria-selected': 'true',
          'tabindex': '0'
        }).addClass('current');

        // Show selected panel - find by matching index
        const $panel = $tabsHolder.find('.tab-content-' + tabIndex);
        if ($panel.length) {
          $panel
            .attr('aria-hidden', 'false')
            .removeAttr('hidden')
            .addClass('current');
        }
      }

      // Initialize: ensure first tab is active
      const $firstTab = $tabs.first();
      const $firstPanel = $panels.first();
      
      // Set initial states
      $tabs.attr({
        'aria-selected': 'false',
        'tabindex': '-1'
      }).removeClass('current');
      
      $panels.attr('aria-hidden', 'true').attr('hidden', true).removeClass('current');
      
      $firstTab.attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).addClass('current');
      
      $firstPanel.attr('aria-hidden', 'false').removeAttr('hidden').addClass('current');
    });
  }

  // Run on load
  initTabAccessibility();

  // Re-run when sections are loaded dynamically
  $(document).on('shopify:section:load', function() {
    initTabAccessibility();
  });
});

